import * as React from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { analyticsState } from 'state/analytics';
import { userSession } from 'state/session';
import { tenantConfig } from 'utils/tenant';
import { getTransparentImages } from 'utils/network/getCarImages';
import { downloadTransparentImagesAsZip } from 'utils/ui/downloadTransparentImagesAsZip';
import { handleDownloadError } from 'utils/ui/handleDownloadError';
import { DownloadMenuButton } from './DownloadMenuButton';

export default function DownloadTransparent2dImageMenuItem() {
  const session = userSession().useState();
  tenantConfig().useState();
  const [isDownloading, setIsDownloading] = React.useState(false);
  const [progress, setProgress] = React.useState<number | null>(null);
  const brand = session.brand;
  const hasImages = Boolean(session.carImages?.items?.length);

  if (!userSession().canDownloadTransparent2dImage || !brand || !hasImages) {
    return false;
  }

  const handleDownload = async () => {
    if (isDownloading) {
      return;
    }

    setIsDownloading(true);
    setProgress(null);
    analyticsState().setValues({ dealerToolUsed: 'downloadTransparentImages' });

    try {
      const images = await getTransparentImages({
        prString: session.prString,
        brand,
      });

      await downloadTransparentImagesAsZip(images.items, session.carDisplayName || undefined, (completed, total) => {
        setProgress(Math.round((completed / total) * 100));
      });
    } catch {
      handleDownloadError('ERROR_TRANSPARENT_2D_DOWNLOAD', t`Failed to download transparent images`);
    } finally {
      setIsDownloading(false);
      setProgress(null);
    }
  };

  return (
    <>
      <DownloadMenuButton
        onClick={handleDownload}
        label={<Trans>Download transparent images</Trans>}
        testId="download-transparent-2d-images"
        loading={isDownloading}
        variant="all"
      />

      {isDownloading && (
        <span data-testid="download-transparent-2d-images-progress" className="sr-only" aria-live="polite">
          {progress === null ? <Trans>Preparing transparent image download…</Trans> : `${progress}%`}
        </span>
      )}
    </>
  );
}
